import { Terminal, Database, Code, FileText, Download } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

export function DeveloperTools() {
  const tools = [
    {
      icon: <Terminal className="w-6 h-6" />,
      title: 'Database Console',
      description: 'Direct access to database queries and management',
      action: 'Open Console',
      onClick: () => console.log('Opening database console')
    },
    {
      icon: <Code className="w-6 h-6" />,
      title: 'API Explorer',
      description: 'Interactive API documentation and testing',
      action: 'Launch Explorer',
      onClick: () => console.log('Opening API explorer')
    },
    {
      icon: <FileText className="w-6 h-6" />,
      title: 'Log Analyzer',
      description: 'Advanced log search and analysis tools',
      action: 'Open Analyzer',
      onClick: () => console.log('Opening log analyzer')
    },
    {
      icon: <Download className="w-6 h-6" />,
      title: 'Data Export',
      description: 'Export system data for analysis',
      action: 'Start Export',
      onClick: () => console.log('Starting data export')
    }
  ];

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <CardTitle>Developer Tools</CardTitle>
          <div className="text-sm text-muted-foreground">
            Advanced tools for system administration and debugging
          </div>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-2 gap-4">
            {tools.map((tool, index) => (
              <Card key={index} className="p-4 hover:shadow-md transition-shadow cursor-pointer">
                <div className="space-y-3">
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-blue-100 rounded-lg text-blue-600">
                      {tool.icon}
                    </div>
                    <div>
                      <h3 className="font-medium text-sm">{tool.title}</h3>
                      <p className="text-xs text-muted-foreground">{tool.description}</p>
                    </div>
                  </div>
                  <Button size="sm" onClick={tool.onClick} className="w-full">
                    {tool.action}
                  </Button>
                </div>
              </Card>
            ))}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}